// const Manage = () => import('@/view/home/manage') //挂载主页面
// const loaderComponent = () => import(/* webpackChunkName: "Manage" */ '@/utils/loaderComponent')
export default (routers, data) => {
    routerFilter(routers, data)
}
function routerFilter(routers, data) {
    data.forEach(item => {
        // console.log(item)
        let menu = Object.assign({}, item)
        if (menu.component != null) {
            if (menu.component === 'Manage') {
                menu.component = () => import('@/view/home/manage')
            } else {
                menu.component = loaderComponent(item.component)
            }
            if (item.children && item.children.length) {
                menu.children = []
                routerFilter(menu.children, item.children)
            }
        }
        routers.push(menu)
    })
}
function loaderComponent(name) {
    // console.log(name)
    if (name === 'productList' || name === 'PrdTraceability' || name === 'templateMarket') {
        return () => import(`@/view/product/${name}`)
        // 企业产品
    } else if (name === 'addProduct' || name === 'addPrdTraceability') {
        return () => import(`@/view/product/add/${name}`)
        // 产品新增
    } else if (name === 'productDetails' || name === 'PrdTraceabilityDetails') {
        return () => import(`@/view/product/details/${name}`)
        // 产品详情
    } else if (name === 'securityCode' || name === 'logisticsCode' || name === 'codeTest' || name === 'codeDiscard') {
        return () => import(`@/view/Sending/${name}`)
        // 发码管理
    } else if (name === 'addSecurityCode' || name === 'addLogisticsCode') {
        return () => import(`@/view/Sending/add/${name}`)
        //新增发码
    } else if (name === 'securityDetails' || name === 'logisticsDetails') {
        return () => import(`@/view/Sending/details/${name}`)
        //发码详情
    } else if (name === 'rollsTransfers' || name === 'warehouse' || name === 'StoreView' || name === 'Putstorage' || name === 'Outstorage' || name === 'transfers' || name === 'inventory' || name === 'OutOrPut' || name === 'infrastructure') {
        return () => import(`@/view/Warehouse/${name}`)
        //仓库管理
    } else if (name === 'addrollsTransfers' || name === 'addWarehouse' || name === 'addPutstorage' || name === 'addOutstorage' || name === 'addtransfers' || name === 'addInventory') {
        return () => import(`@/view/Warehouse/add/${name}`)
        //新增仓库
    } else if (name === 'rollsTransfersDetails' || name === 'warehouseDetails' || name === 'OutstorageDetails' || name === 'transfersDetails' || name === 'inventoryDetails' || name === 'OutOrPutDetails') {
        return () => import(`@/view/Warehouse/details/${name}`)
        //仓库详情
    } else if (name === 'supplier' || name === 'purchaseOrder' || name === 'purchaseRreturn' || name === 'purchaseCompany') {
        return () => import(`@/view/procurement/${name}`)
        //采购管理
    } else if (name === 'addSupplier' || name === 'addpurchaseOrder' || name === 'addPurchaseRreturn') {
        return () => import(`@/view/procurement/add/${name}`)
        //新增采购
    } else if (name === 'supply' || name === 'purOrderDetails' || name === 'PurchaseReturnDetails') {
        return () => import(`@/view/procurement/details/${name}`)
        //采购详情
    } else if (name === 'Operationlog' || name === 'Account' || name === 'Information' || name === 'mpAccount' || name === 'Members' || name === 'choice') {
        return () => import(`@/view/userInfo/${name}`)
        //账号管理
    } else if (name === 'renZheng') {
        return () => import(`@/view/userInfo/add/${name}`)
        // 新增认证
    } else if (name === 'billingDetails') {
        return () => import(`@/view/userInfo/details/${name}`)

    } else if (name === 'dealerList' || name === 'goodsManager' || name === 'scanList' || name === 'checkSalesRecord') {
        return () => import(`@/view/merchant/${name}`)
        //物流管理
    } else if (name === 'addDealer') {
        return () => import(`@/view/merchant/add/${name}`)
        //新增经销商
    } else if (name === 'dealerDetails' || name === 'scanListDetails') {
        return () => import(`@/view/merchant/details/${name}`)
        //物流详情
    } else if (name === 'fleeingGoodsWarning' || name === 'shipmentList' || name === 'returnRecord') {
        return () => import(`@/view/logistics/${name}`)
        //物流管理
    } else if (name === 'returnOrder' || name === 'shipOrder') {
        return () => import(`@/view/logistics/add/${name}`)

    } else if (name === 'returnDetails') {
        return () => import(`@/view/logistics/details/${name}`)

    } else if (name === 'onProduct' || name === 'shopOrder' || name === 'afterSales') {
        return () => import(`@/view/Salesmanag/${name}`)

    } else if (name === 'shopOrderDetails' || name === 'afterSalesDetails') {
        return () => import(`@/view/Salesmanag/details/${name}`)

    } else if (name === 'article' || name === 'memberInfo') {
        return () => import(`@/view/marketing/${name}`)

    } else if (name === 'addArticle') {
        return () => import(`@/view/marketing/add/${name}`)

    } else if (name === 'articleDetails' || name === 'memberDetails') {
        return () => import(`@/view/marketing/details/${name}`)

    } else if (name === 'queryChart' || name === 'sendCodeData' || name === 'fleeGoods' || name === 'shipment') {
        return () => import(`@/view/dataStatistics/${name}`)

    } else if (name === 'key' || name === 'FeatureSet') {
        return () => import(`@/view/set/${name}`)

    } else if (name === 'protocol') {
        return () => import(`@/view/protocol/${name}`)

    } else if (name === 'NotFound' || name === 'Unauthorized') {
        return () => import(`@/view/errorPage/${name}`)
    } else if (name === 'index') {
        return () => import(`@/view/index/${name}`)
    }

}



// WEBPACK FOOTER //
// ./src/utils/filterRouter.js